export default "/images/analytic.png?445ab818a9893868c45ec000d2b5f1ff";